module.exports = __webpack_public_path__ + "img/Flunder_13.c0198963.jpg";